<footer>
  <div class="container">

    <div class="grid">
      <div *ngFor="let category of categories">
        <div class="list-icon">
          <p class="list-icon__title" [routerLink]="['/category', category.slug]">{{ category.name }}</p>
          <ul>
            <li *ngFor="let sub of category.subCategory">
              <div [routerLink]="['/category', sub.slug]">{{ sub.categoryName }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-3 col-6">
        <div class="list-icon">
          <p class="list-icon__title">Get In Touch</p>
          <ul>
            <li>
              <svg viewBox="0 0 24 25" fill="none">
                <path
                  d="M12 17.2871L13 15.2871V10.1451C14.721 9.69811 16 8.14511 16 6.28711C16 4.08111 14.206 2.28711 12 2.28711C9.794 2.28711 8 4.08111 8 6.28711C8 8.14511 9.279 9.69811 11 10.1451V15.2871L12 17.2871ZM10 6.28711C10 5.18411 10.897 4.28711 12 4.28711C13.103 4.28711 14 5.18411 14 6.28711C14 7.39011 13.103 8.28711 12 8.28711C10.897 8.28711 10 7.39011 10 6.28711Z" />
                <path
                  d="M16.267 10.8501L15.734 12.7781C18.325 13.4941 20 14.8711 20 16.2871C20 18.1791 16.715 20.2871 12 20.2871C7.285 20.2871 4 18.1791 4 16.2871C4 14.8711 5.675 13.4941 8.267 12.7771L7.734 10.8491C4.197 11.8271 2 13.9101 2 16.2871C2 19.6511 6.393 22.2871 12 22.2871C17.607 22.2871 22 19.6511 22 16.2871C22 13.9101 19.803 11.8271 16.267 10.8501Z" />
              </svg>
              <div>70 Shenton Wy, #15 02, Singapore 079118</div>
            </li>
            <li>
              <svg viewBox="0 0 20 21" fill="none">
                <path
                  d="M14.57 20.2873C14.8356 20.2888 15.0989 20.2374 15.3444 20.1361C15.5899 20.0348 15.8128 19.8856 16 19.6973L18.71 16.9873C18.8963 16.7999 19.0008 16.5464 19.0008 16.2823C19.0008 16.0181 18.8963 15.7646 18.71 15.5773L14.71 11.5773C14.5227 11.391 14.2692 11.2865 14.005 11.2865C13.7408 11.2865 13.4874 11.391 13.3 11.5773L11.7 13.1673C10.5923 12.8719 9.56634 12.3281 8.70003 11.5773C7.95115 10.7096 7.40766 9.6841 7.11003 8.57725L8.70003 6.97725C8.88628 6.78989 8.99083 6.53644 8.99083 6.27225C8.99083 6.00807 8.88628 5.75461 8.70003 5.56725L4.70003 1.56725C4.51267 1.381 4.25922 1.27646 3.99503 1.27646C3.73085 1.27646 3.4774 1.381 3.29003 1.56725L0.590033 4.28725C0.401665 4.47449 0.252479 4.69738 0.15118 4.9429C0.049881 5.18842 -0.00150075 5.45166 3.33667e-05 5.71725C0.0907563 9.55954 1.62611 13.2265 4.30003 15.9873C7.06075 18.6612 10.7277 20.1965 14.57 20.2873ZM4.00003 3.69725L6.59003 6.28725L5.30003 7.57725C5.17785 7.6917 5.08636 7.83499 5.03395 7.99398C4.98153 8.15297 4.96987 8.32258 5.00003 8.48725C5.3738 10.1576 6.16514 11.7059 7.30003 12.9873C8.58039 14.1236 10.1291 14.9151 11.8 15.2873C11.9622 15.3212 12.1303 15.3142 12.2891 15.2671C12.4479 15.22 12.5926 15.1341 12.71 15.0173L14 13.6973L16.59 16.2873L14.59 18.2873C11.2738 18.2019 8.10954 16.8784 5.72003 14.5773C3.41295 12.1868 2.08564 9.01836 2.00003 5.69725L4.00003 3.69725ZM18 9.28725p0C20.026 8.09825 19.8109 6.91631 19.3678 5.81266C18.9247 4.70901 18.2627 3.7065 17.4217 2.86555C16.5808 2.0246 15.5783 1.36262 14.4746 0.919504C13.371 0.476391 12.189 0.26132 11 0.287251V2.28725C11.9279 2.25515 12.8525 2.41426 13.7163 2.75468C14.5801 3.09511 15.3647 3.60957 16.0212 4.26609C16.6777 4.92261 17.1922 5.70716 17.5326 6.57096C17.873 7.43476 18.0321 8.35935 18 9.28725Z" />
                <path
                  d="M11.0001 6.28723C13.1001 6.28723 14.0001 7.18723 14.0001 9.28723H16.0001C16.0001 6.06723 14.2201 4.28723 11.0001 4.28723V6.28723Z" />
              </svg>

              <div>+65 8120 7644</div>
            </li>
            <!-- <li>
              <svg viewBox="0 0 20 16" fill="none">
                <path
                  d="M18 0H4C2.897 0 2 0.897 2 2V6.99999H4V4L10.4 8.79999C10.5732 8.92969 10.7837 8.99979 11 8.99979C11.2163 8.99979 11.4268 8.92969 11.6 8.79999L18 4V13H10V15H18C19.103 15 20 14.103 20 13V2C20 0.897 19.103 0 18 0ZM11 6.74999L4.666 2H17.334L11 6.74999Z" />
                <path d="M0 8H7V10H0V8ZM2 11H8V13pV11ZM5 14H9V16H5V14Z" />
              </svg>

              <div>joel.thomas&#64;kachiing.com</div>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="col-lg-3 col-6">
        <div class="list">
          <p class="list__title">Community links</p>
          <ul>
            <li>
              <a routerLinkActive="active" routerLink="/me/nearby">Services</a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/me/rental">Rental</a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/me/free">Free</a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/me/events">Events</a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/me/list">List</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-3 col-6">
        <div class="list">
          <p class="list__title">Discussion links</p>
          <ul>
            <li><a routerLinkActive="active" routerLink="/forum">Forum</a></li>
            <li>
              <a routerLinkActive="active" routerLink="/giveaway">Giveaway</a>
            </li>
            <li><a routerLinkActive="active" routerLink="/forum/poll">Poll</a></li>
          </ul>
        </div>
      </div>

      <div class="col-lg-3 col-6">
        <div class="list">
          <p class="list__title">Socials</p>
          <ul>
            <!-- <li>
              <a href="https://www.facebook.com/kachiingcommunity/about_details" target="_blank">Facebook</a>
            </li> -->
            <li>
              <a href="https://www.instagram.com/kachiingsg" target="_blank">Instagram</a>
            </li>
            <li>
              <a href="https://t.me/kachiing_sg" target="_blank">Telegram</a>
            </li>
            <li>
              <a href="https://t.me/kachiing_sg">Telegram Drivers</a>
            </li>
          </ul>
        </div>
        <button class="join-biz-button" routerLink="biz/join">JOIN US</button>
      </div>

      <div class="col-lg-3 col-6">
        <div class="list">
          <p class="list__title">Other</p>
          <ul>
            <li>
              <a routerLink="patch-Note">Patch-Note</a>
            </li>
            <li>
              <a routerLink="privacy">Privacy Policy</a>
            </li>
            <li>
              <a routerLink="policies">Terms of Service</a>
            </li>
            <li>
              <a routerLink="contact-us">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <a to="/">
        <div class="logo">
          <svg viewBox="0 0 127 122" fill="none">
            <path
              d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
            <path
              d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
            <path
              d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
            <path
              d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
            <path
              d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
          </svg>
          <div class="logo--content">
            <div class="logo--content__title">Kachiing</div>
            <div class="logo--content__desc">Everyone Wins With Kachiing</div>
          </div>
        </div>
      </a>
      <div>© 2024 Kachiing. All rights reserved. v1.0.0</div>
    </div>
  </div>
</footer>